import { createRouter, createWebHistory } from 'vue-router';
import HomePage from '@/views/HomePage.vue';
import GreetingPage from '@/views/GreetingPage.vue';
import NewsItemPage from '@/views/NewsItemPage.vue';
import AdminPage from '@/views/AdminPage.vue';
import tokenService from '@/services/tokenService';
import TreatmentListPage from '@/views/TreatmentListPage.vue';
import TreatmentDetailPage from '@/views/TreatmentDetailPage.vue';
import NurseRecruitmentPage from '@/views/NurseRecruitmentPage.vue';
import MedicalOfficeRecruitmentPage from '@/views/MedicalOfficeRecruitmentPage.vue';

const routes = [
  {
    path: '/',
    name: 'HomePage',
    component: HomePage,
  },
  {
    path: '/greeting',
    name: 'GreetingPage',
    component: GreetingPage,
  },
  {
    path: '/news/:newsId',
    name: 'NewsItemPage',
    component: NewsItemPage,
    props: true
  },
  {
    path: '/treatment/:treatmentCategory',
    name: 'TreatmentListPage',
    component: TreatmentListPage,
    props: true
  },
  {
    path: '/treatment/:treatmentCategory/:treatmentId',
    name: 'TreatmentDetailPage',
    component: TreatmentDetailPage,
    props: true
  },
  {
    path: '/recruitment/nurse',
    name: 'NurseRecruitmentPage',
    component: NurseRecruitmentPage,
  },
  {
    path: '/recruitment/medical-office',
    name: 'MedicalOfficeRecruitmentPage',
    component: MedicalOfficeRecruitmentPage,
  },
  {
    path: '/admin',
    name: 'AdminPage',
    component: AdminPage,
  },
  {
    path: '/admin-login',
    name: 'AdminLogin',
    beforeEnter: (to, from, next) => {
      const hash = window.location.hash.slice(1);
      const params = new URLSearchParams(hash);
      const idToken = params.get('id_token');
  
      if (idToken) {
        tokenService.setSessionToken('id_token', idToken);
        next({ name: 'AdminPage' });
      } else {
        tokenService.deleteSessionToken('id_token');
        const cognitoUrl = `https://ap-northeast-1xz13oba8d.auth.ap-northeast-1.amazoncognito.com/login?client_id=1pgt4sd58jo6202ddc17skg4ud&redirect_uri=https%3A%2F%2Faozoraclinic.jp%2Fadmin-login&response_type=token&scope=email+openid+phone`;
        window.location.href = cognitoUrl;
        next(false);
      }
    },
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('../views/NotFoundPage.vue'),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      // 前のページのスクロール位置を復元
      return savedPosition;
    } else if (to.hash) {
      // ハッシュリンクがある場合
      return new Promise((resolve) => {
        setTimeout(() => {
          const element = document.querySelector(to.hash);
          if (element) {
            const offset = 130; // スクロール位置を少し上にあげる (例: 50px)
            const elementPosition = element.getBoundingClientRect().top + window.scrollY;
            resolve({
              top: elementPosition - offset,
              behavior: 'smooth',
            });
          } else {
            // ハッシュターゲットが見つからない場合
            resolve({ top: 0, behavior: 'smooth' });
          }
        }, 300); // 必要ならローディング時間に応じて遅延を調整
      });
    } else {
      // デフォルトでページトップへ
      return { top: 0 };
    }
  },
});

// ✅ グローバルルートガード（ここで自動ログアウトもチェック）
router.beforeEach((to, from, next) => {
  if (to.name === 'AdminPage') {
    const token = tokenService.getSessionToken('id_token');
    if (!token || tokenService.isTokenExpired(token)) {
      tokenService.deleteSessionToken('id_token');
      alert('セッションが切れました。再ログインしてください。');
      next('/admin-login');
      return;
    }
  }
  next();
});

export default router;
